import { Switch, TextField } from "@material-ui/core";
import React, { Component } from "react";
import { Col, Button, Row, Modal } from "react-bootstrap";
import { NavLink } from "react-router-dom";

class ModelBodyMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      switch: false,
      open: false,
    };
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleChangeSwitch = (e) => {
    this.setState({ switch: !this.state.switch });
  };
  render() {
    // const {switch}  = this.state;
    return (
      <div>
        <TextField
          label="Title"
          variant="outlined"
          name="title"
          value={this.state.title}
          onChange={this.onChange}
        />
        <br />
        <div className="d-flex align-items-center py-4">
          {/* pl-md-4 */}
          <div className="f16-500 mr-2">All Day &nbsp; No</div>
          <Switch
            onChange={this.handleChangeSwitch}
            checked={this.state.switch}
            // offColor="#EEEEEE"
            // onColor="#EEEEEE"
            // offHandleColor="#212121"
            // onHandleColor="#59F832"
            // handleDiameter={24}
            // uncheckedIcon={false}
            // checkedIcon={false}
            // height={15}
            // width={41}
            // boxShadow="-2px 0px 5px #0000003B"
            // activeBoxShadow="-2px 0px 5px #0000003B"
            // id="material-switch"
            // disabled={disabled === true ? true : false}
          />
          <div className="f16-500 ml-2">Yes</div>
        </div>
        <div className="row">
          <Col md={this.state.switch ? 5 : 3}>
            <TextField
              label="Date"
              variant="outlined"
              type="date"
              className="w-100"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Col>
          {!this.state.switch && (
            <Col md={2}>
              <TextField
                label="Time"
                variant="outlined"
                type="time"
                className="w-100"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Col>
          )}
          <Col md={2} align="center">
            <div className="f16-500 "> To</div>
          </Col>
          <Col md={this.state.switch ? 5 : 3}>
            <TextField
              label="Date"
              variant="outlined"
              type="date"
              className="w-100"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Col>
          {!this.state.switch && (
            <Col md={2}>
              <TextField
                label="Time"
                variant="outlined"
                type="time"
                className="w-100"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Col>
          )}
        </div>
        {this.props.add && (
          <Row>
            <BlockDatesModel
              open={this.state.open}
              closeModel={() => {
                this.setState({ open: false });
              }}
            />
            <Col md={6}>
              <br />
              <TextField
                label="Description"
                variant="outlined"
                multiline
                rows="4"
                fullWidth
              />
            </Col>
          </Row>
        )}
        <div className="d-flex align-items-center pt-4">
          <NavLink to="/manage-block-reservation-calendar">
            <Button
              variant="outline-secondary"
              className="btn150px btn-lg mr-4 px-5"
            >
              Cancel
            </Button>
          </NavLink>
          <Button
            variant="danger"
            className="btn150px btn-lg px-5"
            onClick={() => {
              this.setState({ open: true });
            }}
          >
            Save
          </Button>
        </div>
      </div>
    );
  }
}

export const BlockDatesModel = (props) => {
  return (
    <React.Fragment>
      <Modal
        show={props.open}
        onHide={() => {
          props.closeModel();
        }}
        centered
        size="md"
      >
        <Modal.Header className="border-0 pl-4" closeButton>
          <Modal.Title className="f24-700">Block Dates / Time Slot</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4 f16-500">
          <p>
            15 Reservations exist for the Date / Time you are looking to block.
            Please cancel the reservations and notify the users about before
            blocking dates/slots
          </p>
          <div className="d-flex align-items-center pt-4">
            <Button
              variant="outline-secondary"
              className="btn150px btn-lg mr-4 px-5"
            >
              No
            </Button>
            <NavLink to="/all-reservations">
              <Button
                variant="danger"
                className="btn150px btn-lg px-5"
                // onClick={() => onClickSave()}
              >
                Yes
              </Button>
            </NavLink>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default ModelBodyMain;
